<template>
    <div
        class="e-accordion__item"
        :class="[parentClass, {'_opened': activated}]"
    >
        <div @click="setActive" class="e-accordion__preview">
            <div v-if="tags.length" class="e-accordion__tags">
                <component
                    @click.stop
                    :is="tag.link ? 'a': 'div'"
                    v-for="(tag, idx) in tags"
                    :key="`tag-${idx}`"
                    :href="tag.link ? tag.link: false"
                    class="e-tag g-text__p _middle"
                >
                    {{ tag.name }}
                </component>
            </div>
            <div class="e-accordion__container">
                <div class="e-accordion__title" v-html="title" />
                <div class="e-accordion__icon"></div>
            </div>
        </div>
        <div
            ref="content"
            :style="{
                overflow: setOverflow ? 'hidden' : 'visible',
                maxHeight: contentHeight + 'px'
            }"
            class="e-accordion__content"
        >
            <div :class="{'_m-reset': mContainerReset}" class="e-accordion__container">
                <div class="e-accordion__text">
                    <slot />
                </div>
            </div>
        </div>
        <div
            ref="fake"
            v-if="dynamic"
            class="e-accordion__content _fake"
        >
            <div :class="{'_m-reset': !mDisableContainerReset}" class="e-accordion__container">
                <div>
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Accordion',
        props: {
            tags: { // если есть теги, передавать
                type: Array,
                default: () => {
                    return [];
                },
            },
            title: {
                type: String,
                default: ''
            },
            parentClass: { // если стили отличаются от базовых
                type: String,
                default: ''
            },
            dynamic: { // если контент будет изменяться динамически
                type: Boolean,
                default: false
            },
            // если контейнер под контент на мобилке должен быть 100% ширины
            // (по умолчанию он вычитает размер иконки и отступа до иконки)
            mDisableContainerReset: {
                type: Boolean,
                default: false
            },
            code: { // код элемента (алтернатива ref)
                type: String,
                default: ''
            },
        },
        data() {
            return {
                curContentHeight: null,
                contentHeight: null,
                setOverflow: true,
                refName: '',
                activated: false
            };
        },
        watch: {
            activated(newVal) {
                if (newVal) {
                    this.contentHeight = this.curContentHeight;

                    setTimeout(() => {
                        this.setOverflow = false;
                    }, 300);
                } else {
                    this.contentHeight = 0;
                    this.setOverflow = true;
                }
            },
            title() {
                this.$nextTick(() => {
                    this.curContentHeight = this.$refs.fake.offsetHeight;
                });
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.curContentHeight = this.$refs.content.offsetHeight;
                this.contentHeight = 0;

                const refList = Object.entries(this.$parent.$refs);
                const refIdx = refList.findIndex((item) => {
                    return item[1] === this || item[1][0] === this;
                });
                if (refIdx !== -1) {
                    this.refName = refList[refIdx][0];
                } else {
                    this.refName = this.code;
                }
            });
        },
        methods: {
            setActive() {
                this.$emit('set-active', this.refName, this.title);
            }
        }
    };
</script>
